import isEmpty from 'lodash-es/isEmpty';

import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';
import { DesktopSector, FlightItem, FlightResultDesktop, Option } from '@app/entities/flight-results';
import { withFareBasic } from '@flight-results/mappers/flights.mapper';
import { PackageResumeHotel } from '@packages/entities/package-resume';
import { HotelDetailPackageResponse } from '@packages/packages-result/entities/hotel-detail';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { getFlightKeysWithEncodeURIComponent } from '@flight-results/mappers/flight-keys.mapper';

export function hasAirSelectedComplete(airSelected: AirResultOptionResponse): boolean {
  return !!airSelected && !isEmpty(airSelected) && !!airSelected.Price && !isEmpty(airSelected.Price);
}

export function hasAirSelectedCompleteDesktop(airSelected: FlightResultDesktop): boolean {
  return !!airSelected && !isEmpty(airSelected) && !!airSelected.Price && !isEmpty(airSelected.Price);
}

export function getFlightItemPackage(item: Option, sector: DesktopSector, flightsLength: number): FlightItem {
  const withFareBasicByCode = withFareBasic(item.Flights[0].AirlineCode);
  const FareFamilies = withFareBasicByCode && item.Flights[0].FareBasis ? item.Flights[0].FareBasis :
    item.Flights[0].FareFamilies;
  return {
    FareBasis: item.Flights[0].FareBasis ?? '',
    FareFamilies: FareFamilies ?? '',
    ArrivalAirport: item.Flights[flightsLength - 1].ArrivalAirport,
    DepartureAirport: item.Flights[0].DepartureAirport,
    AirlineCode: item.Flights[0].AirlineCode,
    AirlineName: item.Flights[0].AirlineName,
    FlightKeys: getFlightKeysWithEncodeURIComponent(item?.FlightKeys),
    ArrivalDate: item.Flights[flightsLength - 1].ArrivalDate,
    SectorNumber: sector.SectorNumber,
    DepartureDate: item.Flights[0].DepartureDate,
  };
}

export function hotelReservationFilter(packageResume: PackageResumeHotel, roomRateId: string): PackageResumeHotel {
  let data = { ...packageResume };
  if (data?.RoomRates?.length && data?.Rooms?.length) {
    const rates = [].concat(...data.RoomRates.filter(rate => !!roomRateId &&
      rate.RateId === roomRateId).map(rate => rate.RoomIds));
    const hasRates = !!rates && !!rates.length;
    const selectRates = hasRates ? rates : [].concat(...data.RoomRates[0]?.RoomIds);
    if (selectRates && selectRates.length) {
      const roomsByRate = data.Rooms.filter(room => selectRates.some(rate => rate === room.RoomId));
      if (roomsByRate && roomsByRate.length) {
        data = { ...data, Rooms: roomsByRate };
      }
    }
  }
  return data;
}

export function getFormatHotelSelectionData(hotel: HotelDetailPackageResponse): HotelSearched {
  return {
    ...hotel.Result,
    HotelName: hotel.Info.HotelName,
    Images: hotel.Info.Images,
    Category: hotel.Info.Category
  };
}
